import { yupResolver } from '@hookform/resolvers/yup'
import { Auth } from 'aws-amplify'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { object, string } from 'yup'

import Button, { ButtonVariant } from '@/components/button'
import Input from '@/components/input'

const schema = object({
  code: string().required(),
  password: string().min(8).required(),
}).required()

const ResetPassword = ({ submittedEmail }) => {
  const router = useRouter()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { code: '', password: '' },
  })

  const onSubmit = useCallback(
    ({ code, password }) => {
      Auth.forgotPasswordSubmit(submittedEmail, code, password)
        .catch(() => {})
        .finally(() => router.push('/auth/login'))
    },
    [router, submittedEmail],
  )

  return (
    <div className='relative'>
      <div className='py-4'>
        <form
          className='auth-form mt-[50px]  flex flex-col space-y-2'
          onSubmit={handleSubmit(onSubmit)}
        >
          <label
            htmlFor='email'
            className='l-col block text-sm font-medium text-gray-700 text-[#E2846F]'
          >
            Code sent to {submittedEmail}
          </label>
          <Input
            name='code'
            label='Code'
            type='text'
            required
            register={register}
            errors={errors}
          />
          <label
            htmlFor='email'
            className='l-col block text-sm font-medium  text-gray-700 text-[#E2846F]'
          >
            Create a password
          </label>
          <Input
            name='password'
            type='password'
            autoComplete='new-password'
            required
            register={register}
            errors={errors}
          />

          <div className='flex w-full justify-end'>
            <Button
              type='submit'
              variant={ButtonVariant.Primary}
              bg='bg-white'
              tailFill='white'
              className='custom-font22 w-fit px-5  py-1.5'
              tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[40%]'
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ResetPassword

ResetPassword.propTypes = {
  submittedEmail: PropTypes.string.isRequired,
}
